module.exports = __webpack_public_path__ + "img/lens-160-minus-08.9fbd74b6.png";